<div class="p-5">
  <div class="flex items-center gap-2 mb-3">
    <mat-icon style="color: #1C593D;">receipt_long</mat-icon>
    <h2 style="font-size: 1.05rem; font-weight: 700; color: #111827; margin: 0;">Detalle de transacción</h2>
  </div>

  <div *ngIf="loading" class="flex justify-center py-6">
    <mat-spinner diameter="28"></mat-spinner>
  </div>

  <div *ngIf="error" class="bg-red-50 border border-red-200 text-red-700 p-3 rounded-lg text-sm">
    ✗ {{ error }}
  </div>

  <div *ngIf="!loading && tx" class="flex flex-col gap-3">
    <!-- Header -->
    <div class="grid grid-cols-2 sm:grid-cols-3 gap-2">
      <div class="bg-gray-50 rounded-lg p-2">
        <div class="text-xs text-gray-500 uppercase font-semibold">Tipo</div>
        <div class="font-bold">{{ getTipoLabel(tx.tipo) }}</div>
      </div>
      <div class="bg-gray-50 rounded-lg p-2">
        <div class="text-xs text-gray-500 uppercase font-semibold">Status</div>
        <span class="px-2 py-0.5 text-xs font-bold rounded-full" [ngClass]="getStatusClass(tx.status)">{{ getStatusLabel(tx.status) }}</span>
      </div>
      <div class="bg-gray-50 rounded-lg p-2">
        <div class="text-xs text-gray-500 uppercase font-semibold">Monto</div>
        <div class="font-bold">{{ tx.monto | number:'1.2-2' }} {{ tx.moneda }}</div>
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
      <div><span class="text-gray-500 font-semibold text-xs uppercase">UUID interno:</span> <code class="text-xs">{{ tx.referenciaInterna }}</code></div>
      <div *ngIf="tx.referenciaBanco"><span class="text-gray-500 font-semibold text-xs uppercase">Ref banco:</span> <code class="text-xs">{{ tx.referenciaBanco }}</code></div>
      <div *ngIf="tx.codBancoDestino"><span class="text-gray-500 font-semibold text-xs uppercase">Cód banco destino:</span> {{ tx.codBancoDestino }}</div>
      <div *ngIf="tx.tipoProposito"><span class="text-gray-500 font-semibold text-xs uppercase">Propósito:</span> {{ tx.tipoProposito }}</div>
      <div *ngIf="tx.tipoInstrumentoB"><span class="text-gray-500 font-semibold text-xs uppercase">Instrumento:</span> {{ tx.tipoInstrumentoB }}</div>
      <div *ngIf="tx.tipoMovimientoBanco"
        [matTooltip]="'Tipo de movimiento devuelto por el banco. TB=Transferencia, Y9=Pago Móvil, DP=Depósito, CO=Cargo/Operación'">
        <span class="text-gray-500 font-semibold text-xs uppercase">Tipo movimiento (banco):</span>
        <code class="text-xs">{{ tx.tipoMovimientoBanco }}</code>
      </div>
      <div *ngIf="tx.naturaleza"><span class="text-gray-500 font-semibold text-xs uppercase">Naturaleza:</span> {{ tx.naturaleza }} <span class="text-xs text-gray-400">({{ tx.naturaleza === 'CR' || tx.naturaleza === 'C' ? 'crédito' : 'débito' }})</span></div>
      <div *ngIf="tx.cuentaOrigen"><span class="text-gray-500 font-semibold text-xs uppercase">Cuenta origen:</span> <code class="text-xs">{{ tx.cuentaOrigen }}</code></div>
      <div *ngIf="tx.cuentaDestino"><span class="text-gray-500 font-semibold text-xs uppercase">Cuenta destino:</span> <code class="text-xs">{{ tx.cuentaDestino }}</code></div>
      <div *ngIf="tx.telefono"><span class="text-gray-500 font-semibold text-xs uppercase">Teléfono:</span> {{ tx.telefono }}</div>
      <div *ngIf="tx.identificacionOrdenante"><span class="text-gray-500 font-semibold text-xs uppercase">Ordenante:</span> {{ tx.identificacionOrdenante }}</div>
      <div *ngIf="tx.identificacionBeneficiario"><span class="text-gray-500 font-semibold text-xs uppercase">Beneficiario:</span> {{ tx.identificacionBeneficiario }}</div>
      <div *ngIf="tx.nombreBeneficiario"><span class="text-gray-500 font-semibold text-xs uppercase">Nombre ben:</span> {{ tx.nombreBeneficiario }}</div>
      <div *ngIf="tx.userId"><span class="text-gray-500 font-semibold text-xs uppercase">User:</span> <code class="text-xs">{{ tx.userId }}</code></div>
      <div *ngIf="tx.operadorEmail"><span class="text-gray-500 font-semibold text-xs uppercase">Operador:</span> {{ tx.operadorEmail }}</div>
      <div><span class="text-gray-500 font-semibold text-xs uppercase">Creada:</span> {{ tx.createdAt | date:'dd/MM/yyyy HH:mm:ss':'America/Caracas' }}</div>
      <div><span class="text-gray-500 font-semibold text-xs uppercase">Actualizada:</span> {{ tx.updatedAt | date:'dd/MM/yyyy HH:mm:ss':'America/Caracas' }}</div>
    </div>

    <!-- ===================================================================
         Cliente y beneficiario, igual que en el detalle de N58.
         Arriba está la versión del banco —lo que se le mandó y lo que
         respondió—, que es inmutable. Esto es nuestro lado: quién es el
         cliente y qué beneficiario de su agenda se usó. Lo cruza el backend
         al leer, no hay columnas nuevas.
         =================================================================== -->
    <div *ngIf="hayContraparte" class="grid grid-cols-1 sm:grid-cols-2 gap-2">

      <div *ngIf="tx.cliente" class="rounded-lg p-2 border" style="background: #f5f3ff; border-color: #ddd6fe;">
        <div class="flex items-center gap-1.5 mb-1">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #6d28d9;">person</mat-icon>
          <span class="text-xs font-bold uppercase" style="color: #6d28d9;">Cliente</span>
        </div>
        <div class="text-sm font-semibold text-gray-900">{{ clienteNombre || '—' }}</div>
        <div class="text-xs text-gray-600 mt-0.5">
          ID: <code>{{ tx.cliente.usuarioId }}</code>
          <span *ngIf="tx.cliente.documento"> · {{ tx.cliente.documento }}</span>
        </div>
        <div *ngIf="tx.cliente.email" class="text-xs text-gray-600" style="word-break: break-all;">
          {{ tx.cliente.email }}
        </div>
        <div *ngIf="tx.cliente.paisResidencia" class="text-xs text-gray-400 mt-0.5">
          {{ tx.cliente.paisResidencia }}
        </div>
      </div>

      <div *ngIf="tx.beneficiario" class="rounded-lg p-2 border" style="background: #fef2f2; border-color: #fecaca;">
        <div class="flex items-center gap-1.5 mb-1">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #b91c1c;">call_made</mat-icon>
          <span class="text-xs font-bold uppercase" style="color: #b91c1c;">Beneficiario</span>
          <span class="text-xs text-gray-400">· nuestro registro</span>
        </div>
        <div class="text-sm font-semibold text-gray-900">{{ tx.beneficiario.nombre || '—' }}</div>
        <div *ngIf="tx.beneficiario.documento" class="text-xs text-gray-600 mt-0.5">
          {{ tx.beneficiario.documento }}
        </div>
        <div *ngIf="tx.beneficiario.cuenta" class="text-xs text-gray-600" style="font-family: monospace;">
          {{ tx.beneficiario.cuenta }}
          <span *ngIf="tx.beneficiario.esPagoMovil" class="text-gray-400">(pago móvil)</span>
        </div>
        <div *ngIf="tx.beneficiario.bancoNombre" class="text-xs text-gray-500 mt-0.5">
          {{ tx.beneficiario.bancoNombre }}
          <span *ngIf="tx.beneficiario.bancoCodigo">({{ tx.beneficiario.bancoCodigo }})</span>
        </div>
        <!-- La ficha es editable por el cliente: puede no ser la misma que se
             usó ese día. Lo inmutable es lo que se le mandó al banco, arriba. -->
        <div class="text-xs text-gray-400 mt-1">Ficha actual del cliente</div>
      </div>

      <div *ngIf="tx.referenciaVes" class="rounded-lg p-2 border" style="background: #eff6ff; border-color: #bfdbfe;">
        <div class="flex items-center gap-1.5 mb-1">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1d4ed8;">assignment_turned_in</mat-icon>
          <span class="text-xs font-bold uppercase" style="color: #1d4ed8;">Referencia declarada</span>
        </div>
        <div class="text-sm font-semibold text-gray-900">{{ tx.referenciaVes.titular || '—' }}</div>
        <div class="text-xs text-gray-600 mt-0.5">
          {{ tx.referenciaVes.banco }}
          <span *ngIf="tx.referenciaVes.cuenta" style="font-family: monospace;">
            · {{ tx.referenciaVes.cuenta }}
          </span>
        </div>
        <div class="text-xs text-gray-600">
          {{ tx.referenciaVes.tipoCuenta }} · {{ tx.referenciaVes.status }}
        </div>
        <div *ngIf="tx.referenciaVes.operatorEmail" class="text-xs text-gray-400 mt-0.5">
          {{ tx.referenciaVes.operatorEmail }}
        </div>
      </div>

    </div>

    <div *ngIf="tx.transaccion" class="bg-gray-50 rounded-lg p-2 text-sm">
      <span class="text-gray-500 font-semibold text-xs uppercase">Transacción:</span>
      <code class="text-xs">{{ tx.transaccion.id }}</code>
      <span class="text-xs text-gray-500"> · {{ tx.transaccion.estado }}</span>
      <span *ngIf="tx.transaccion.montoOrigen" class="text-xs text-gray-600">
        · {{ tx.transaccion.montoOrigen | number:'1.2-2' }} {{ tx.transaccion.monedaOrigen }}
        → {{ tx.transaccion.montoDestino | number:'1.2-2' }} {{ tx.transaccion.monedaDestino }}
      </span>
    </div>

    <div *ngIf="tx.concepto" class="bg-yellow-50 border border-yellow-200 rounded-lg p-2 text-sm">
      <strong class="text-yellow-800">Concepto:</strong> {{ tx.concepto }}
    </div>

    <div *ngIf="tx.codigoRespuesta" class="bg-blue-50 border border-blue-200 rounded-lg p-2 text-sm">
      <strong class="text-blue-800">Respuesta API:</strong> {{ tx.codigoRespuesta }} — {{ tx.descripcionRespuesta }}
    </div>

    <!-- Raw payloads collapsible -->
    <details class="bg-gray-50 rounded-lg p-2">
      <summary class="cursor-pointer font-semibold text-xs text-gray-700">Raw request</summary>
      <pre class="text-xs overflow-auto mt-2" style="max-height: 240px;">{{ tx.rawRequest | json }}</pre>
    </details>
    <details class="bg-gray-50 rounded-lg p-2">
      <summary class="cursor-pointer font-semibold text-xs text-gray-700">Raw response</summary>
      <pre class="text-xs overflow-auto mt-2" style="max-height: 240px;">{{ tx.rawResponse | json }}</pre>
    </details>
    <details *ngIf="tx.settlementRaw" class="bg-gray-50 rounded-lg p-2">
      <summary class="cursor-pointer font-semibold text-xs text-gray-700">Settlement raw</summary>
      <pre class="text-xs overflow-auto mt-2" style="max-height: 240px;">{{ tx.settlementRaw | json }}</pre>
    </details>
  </div>

  <div class="flex justify-end mt-4">
    <button type="button" (click)="close()"
      style="padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer;">
      Cerrar
    </button>
  </div>
</div>
